import { getAPIUrl } from "../config";

const API_URL = getAPIUrl();

export const fetchOrders = async (venueId, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();

    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/orders`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch orders');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching orders:', error);
    throw error;
  }
};
